<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('kds.kitchenDisplayScreen')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card mar-to-15">
          <div class="card-content">
            <div class="text-right">
              <p>
                <button class="btn add mar-rt-10"  @click.prevent="goToAdd" :title="$t('general.add')">
                  <img src="/static/img/icons/add.png">
                  {{$t('general.add')}}
                </button>
              </p>
            </div>
            <data-tables
              v-loading="loading"
              :data="tableData"
              :search-def="{}"
              :pagination-def="{}"
              :table-props="{'border': false}"
              style="width: 100%">

              <!-- Define your table columns -->
              <el-table-column
                min-width="20"
                prop="id"
                label="ID">
                <template slot-scope="props">
                  <div class="cell-center">{{ props.row.id || '-' }}</div>
                </template>
              </el-table-column>

              <el-table-column
                min-width="40"
                prop="name"
                :label="$t('kds.name')">
                <template slot-scope="props">
                  <div class="cell-center">{{ props.row.name || '-' }}</div>
                </template>
              </el-table-column>

              <el-table-column
                min-width="20"
                prop="is_offline"
                label="Offline">
                <template slot-scope="props">
                  <template v-if="props.row.is_offline">
                    <div class="cell-center" style="color: green;">{{ $t('general.yes') }}</div>
                  </template>
                  <template v-else>
                    <div class="cell-center" style="color: red;">{{ $t('general.no') }}</div>
                  </template>
                </template>
              </el-table-column>

              <el-table-column
                min-width="50"
                prop="location_name"
                :label="$t('orders.location')">
                <template slot-scope="props">
                  <template v-if="props.row.locations.length">
                    <span>
                      <template v-for="location in props.row.locations">
                        {{ location.name }}
                      </template>
                    </span>
                  </template>
                  <template v-else>
                    <div class="cell-center">{{ $t('general.all') }}</div>
                  </template>
                </template>
              </el-table-column>

              <el-table-column
                width="170"
                prop="sections"
                :label="$t('kds.section')">
                <template slot-scope="props">
                  <el-tooltip
                    v-if="getRowSectionNames(props.row).length"
                    placement="top"
                    effect="dark"
                    :open-delay="200">
                    <div slot="content" class="sections-tooltip">
                      <div
                        v-for="(name, index) in getRowSectionNames(props.row)"
                        :key="index">
                        {{ name }}
                      </div>
                    </div>
                    <div class="sections-cell">
                      <span class="sections-name">{{ getVisibleSectionNames(props.row) }}</span>
                      <span v-if="getHiddenSectionCount(props.row)" class="sections-more">
                        +{{ getHiddenSectionCount(props.row) }}
                      </span>
                    </div>
                  </el-tooltip>
                  <div v-else class="cell-center">{{ $t('general.all') }}</div>
                </template>
              </el-table-column>

              <el-table-column
                :width="320"
                :label="$t('general.actions')">
                <template slot-scope="props">
                  <a
                    class="btn delete mar-rt-10"
                    :title="$t('marketingCampaigns.send')"
                    @click="handleDelete(props.row.id)">
                    <img src="/static/img/icons/icon-close.png">
                    {{$t('general.delete')}}
                  </a>
                  <div class="edit" @click="goToRecord(props.row, $event, props.row)">
                    <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import swal from 'sweetalert2'
import { Tooltip } from 'element-ui'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import 'sweetalert2/dist/sweetalert2.css'

Vue.use(Tooltip)

export default {
  components: {
    // GeneralTopBar
  },
  created () {
    this.getData()

    this.$bus.$on('refresh', this.handleRefresh)
  },
  // mounted () {
  //   this.$bus.$on('refresh', this.handleRefresh)
  // },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
  },
  data () {
    return {
      loading: true,
      tableData: [],
      isNew: false,
      model: {},
      maxVisibleSections: 3
    }
  },
  methods: {
    handleRefresh () {
      this.getData()
    },
    goToRecord (row, event, column) {
      // this.$router.push('/screens/kds/edit/' + row.id)

      if (typeof this.callback === 'function') {
        this.callback(row.id)
      } else {
        this.globalGoToRecord(row, event, column, '/screens/kds/edit/')
      }
    },
    goToAdd () {
      this.$router.push('/screens/kds/add')
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    getRowSectionNames (row) {
      if (row.sections && row.sections.length) {
        return row.sections.map(section => section.name)
      }
      if (row.section && row.section.name) {
        return [row.section.name]
      }
      return []
    },
    getVisibleSectionNames (row) {
      const names = this.getRowSectionNames(row)
      if (!names.length) {
        return this.$t('general.all')
      }
      return names.slice(0, this.maxVisibleSections).join(', ')
    },
    getHiddenSectionCount (row) {
      const names = this.getRowSectionNames(row)
      if (names.length <= this.maxVisibleSections) {
        return 0
      }
      return names.length - this.maxVisibleSections
    },
    getData () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/kds', 'GET', data, response => {
        if (response.status === true) {
          this.tableData = response.data
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    handleDelete (item) {
      var btnCounter = 3
      swal({
        text: this.$t('kds.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('marketingFidelities.yes') + ' (' + btnCounter + ')'
      })
      .then((result) => {
        if (result) {
          const data = {
            id: item,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/kds/' + item, 'DELETE', data, (response) => {
            if (response.status === true) {
              this.trackAdminEvent('ADMIN_KDS_DELETED', 'kds', item, {
                kds_id: item
              })
              swal(
                '',
                this.$t('general.success'),
                'success'
              )
              this.getData()
            } else {
              swal(
                '',
                response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
                'error'
              )
            }
          })
          // }
        }
      })
      .catch((err) => {
        if (err) {
        }
      })
      swal.disableConfirmButton()
      const yes = this.$t('general.yes')
      const btnInterval = setInterval(() => {
        btnCounter--
        if (btnCounter >= 1) {
          if (swal.getConfirmButton()) {
            swal.getConfirmButton().textContent = `${yes} (${btnCounter})`
          }
        } else {
          if (swal.getConfirmButton()) {
            swal.getConfirmButton().textContent = yes
          }
          clearInterval(btnInterval)
          swal.enableConfirmButton()
        }
      }, 1000)
    }
  }
}
</script>

<style>
  td.error-spelling-fix-position textarea.label-notification-textarea {
    resize: vertical !important;
    overflow: hidden !important;
    min-height: auto !important;
  }

  .delivery_method{
    display: flex;
    flex-direction: column;
  }
  .delivery_method_points{
    display: flex;
    align-items: center;
    gap: 30px;
    margin-bottom: 10px;
  }

  .delivery_method_points :first-child {
    width: 300px;
  }

  .loyaltyPointsModal__footer {
    text-align: end;
  }

  .loyaltyModal {
    text-align: center;
  }

  .sections-cell {
    align-items: center;
    cursor: default;
    display: inline-flex;
    max-width: 100%;
    overflow: hidden;
  }

  .sections-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sections-more {
    background: #674BD2;
    border-radius: 10px;
    color: #fff;
    flex: 0 0 auto;
    font-size: 11px;
    line-height: 1;
    margin-left: 6px;
    padding: 3px 6px;
  }

  .sections-tooltip div + div {
    margin-top: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/Kds/Kds.vue